import PropTypes from 'prop-types';
import React from 'react';

import t from '../../../labels/labelling-utils';
import { Role as PlayerRole, Role, roleList as playerRoleList } from '../../../typings/player';
import { isEmptyArray } from '../../../utils/array';
import { getErrorComponent } from '../../../utils/helper-components';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import TableHead from '../../atoms/table-head/table-head';
import TeamRow, { ITeamRow } from '../../molecules/team-row/team-row';
import ErrorBoundary from '../../templates/error-boundary/error-boundary';

import './team-players-table.scss';

export interface ITeamPlayer extends ITeamRow {
  role: PlayerRole;
  // UNUSED  fields (from BE query)
  id?: string;
  name?: string;
  surname?: string;
}

export interface ITeamPlayersTable {
  playerList: ITeamPlayer[];
}

const classNames = (): IClassNames => {
  return makeClassNames({
    table: 'team-players-table',
    body: 'team-players-table__body',
    header: 'team-players-table__header',
    headerTd: 'team-players-table__header-td',
  });
};

const TeamPlayersTable: React.FC<ITeamPlayersTable> = ({
  /* istanbul ignore next: default value */ playerList = [],
}) => {
  const cn = classNames();

  const columnsLabels = [
    t('team.players.th.number'),
    t('team.players.th.country'),
    t('team.players.th.name'),
    t('team.players.th.age'),
    t('team.players.th.height'),
    t('team.players.th.weight'),
  ];

  const labelsRole: {
    [key in Role]: string;
  } = {
    Goalkeeper: t('team.players.label.keeper'),
    Defender: t('team.players.label.fullback'),
    Midfielder: t('team.players.label.midfielder'),
    Forward: t('team.players.label.striker'),
    Manager: t('team.players.label.coach'),
  };

  return (
    <ErrorBoundary hasError={isEmptyArray(playerList)} errorComponent={getErrorComponent()}>
      <table className={cn.table}>
        <TableHead columns={columnsLabels} />
        <tbody className={cn.body}>
          {/* Iterate ROLES */}
          {playerRoleList.map((role: Role) => {
            // Take only PLAYERS with given ROLE
            const players: ITeamPlayer[] = playerList.filter((player) => player.role === role);
            // .sort((prev, next) => prev.jerseyNum - next.jerseyNum);

            return (
              <React.Fragment key={role}>
                {players.length ? (
                  <tr className={cn.header}>
                    <td className={cn.headerTd} colSpan={columnsLabels.length}>
                      {labelsRole[role]}
                      {'\u00a0'}
                    </td>
                  </tr>
                ) : null}
                {players.length
                  ? players.map((player: ITeamPlayer, index: number) => <TeamRow key={index} {...player} />)
                  : null}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </ErrorBoundary>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  TeamPlayersTable.propTypes = {
    // @ts-ignore
    playerList: PropTypes.arrayOf(
      PropTypes.shape({
        ...TeamRow.propTypes!,
        role: PropTypes.oneOf(playerRoleList).isRequired,
      }).isRequired
    ).isRequired,
  };
}

export default TeamPlayersTable;
